import { getTranslations } from '@lib/api/index';
import React, { useState, useEffect } from 'react';
import { TooltipInfoIcon } from '@icons';
import ReusableTable from 'components/reusableTable/reusableTable';

const MonitoringProjectsTable = ({ rowData }) => {
  const [translations, setTranslations] = useState([]);

  useEffect(() => {
    getTranslations().then((retrievedTranslation) => {
      setTranslations(retrievedTranslation);
    });
  }, []);
  const jsxInCell = (params) => {
    return (
      <div className='d-flex justify-content-between align-items-center' style={{ zIndex: 9999 }}>
        {params.data.requestId} <TooltipInfoIcon style={{ width: '1rem', minWidth: '1rem' }} />
      </div>
    );
  };
  const columnDefs = [
    {
      headerName: translations
        .filter((trans) => trans.code === 'ICS002')
        .map((trans) => {
          return trans.text;
        }),
      field: 'clientId',
      filter: 'agTextColumnFilter',
    },
    {
      headerName: translations
        .filter((trans) => trans.code === 'ICS003')
        .map((trans) => trans.text),
      field: 'requestId',
      filter: 'agTextColumnFilter',
      // tooltipField: 'requestId',
      // //tooltipComponentParams: { color: 'red' }, //not work
      // cellRendererSelector: () => {
      //   const idAndSvg = {
      //     component: jsxInCell,
      //   };

      //   return idAndSvg;
      // },
    },

    {
      headerName: translations
        .filter((trans) => trans.code === 'ICS053')
        .map((trans) => trans.text),
      field: 'rating',
      cellStyle: { textAlign: 'center' },
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'equals'],
        defaultOption: 'equals',
      },
    },
  ];
  return <ReusableTable columnDefs={columnDefs} rowData={rowData ?? []} />;
};

export default MonitoringProjectsTable;
